module.exports = __WEBPACK_EXTERNAL_MODULE_61__;


//////////////////
// WEBPACK FOOTER
// external "mobx"
// module id = 61
// module chunks = 0